<template>
    <div>
        <div id="loading-Icon" >
            <img
                src="/site/theme/images/loader.gif"
                alt="loading"
            />
        </div>
    </div>
</template>

<script>
export default { name: 'Loading' };
</script>
